// extracted by mini-css-extract-plugin
module.exports = {"visible":"ChatInstruction_visible_3pi1j","component":"ChatInstruction_component_zZ9jw"};